import { WorkingHour } from '../../types/salary-calculator.types';
import { get } from '../api.service';

export interface DeductionRecord {
    amountPerUnit: number;
    articleNumber: string;
    customerName: string;
    houseworkType: string;
    id: number;
    invoice: Invoice[];
    invoiceId: number;
    invoiceNumber: number;
    isActive: boolean;
    number: number;
    unit: string;
    userId: number;
    workingDate: string; 
    workingDescription: string; 
    workingHour: number;
}

export interface Invoice {
    administratorFee: number | null;
    amount: number;
    amountDeductingCurrencyMargin: number;
    amountInSEK: number;
    amountIncVat: number;
    createdBy: number;
    createdByEmail: string | null;
    createdDate: string;
    creditInvoiceNumber: number;
    creditOriginInvoiceNumber: number;
    currency: string;
    currencyRate: number;
    customer: any | null;
    customerId: number;
    description: string;
    dueDate: string;
    employeeSalary: any | null;
    estimatedNetSalary: number | null;
    expressPayout: boolean;
    expressPayoutAmount: number;
    fakturaNuFee: number;
    feePercentage: number;
    foreignBankFee: number;
    fortnoxInvoiceNumber: number;
    holidaySavings: boolean;
    holidaySavingsAmount: number;
    holidaySavingsFee: number;
    hourlyWagesAmountPerUnit: number | null;
    id: number;
    incomeTaxReductionInSek: number;
    invoiceFileUpload: any[];
    invoiceFreelancer: any[];
    invoiceNumber: number;
    invoicePurposeType: number;
    invoiceSalaryStatus: number;
    invoiceStageForUserView: number;
    invoiceStatus: number;
    invoiceType: number;
    isActive: boolean;
    isAuthorizedForReminder: boolean;
    isBooked: boolean;
    isCreditInvoiceRequested: boolean | null;
    isEditInvoiceRequestApproved: boolean;
    isEditInvoiceRequestRejected: boolean;
    isEditInvoiceRequested: boolean;
    isEmailSent: boolean;
    isFileuploadedOnFortnox: boolean;
    isFixed: boolean;
    isHaveCreditInvoice: boolean;
    isInvoiceAddedOnFortnox: boolean;
    isInvoiceCanceledOnFortnox: boolean;
    isInvoiceUpdatedOnFortnox: boolean;
    isPfdAttached: boolean;
    isReminderInvoice: boolean;
    isReverseVatApplied: boolean;
    isSalaryCreated: boolean;
    isSalaryPaidThroughInvoiceStatus: boolean;
    isSalaryStatusUpdatedManually: boolean;
    isTaxReductioncreatedOnFortnox: boolean;
    isUserUploadedToComplyCube: boolean | null;
    minimumFee: number;
    multipleFreelancer: boolean;
    notes: boolean;
    ocrNumber: number;
    pension: boolean;
    pensionAmount: number;
    pensionFee: number;
    pensionFeePer: number;
    registerAssignment: boolean;
    relatedInvoice: any | null;
    relatedInvoiceId: number | null;
    reminderInvoiceNumber: number | null;
    reverseVatType: any | null;
    rotAccommodationDeductionType: any | null;
    rotDeduction: boolean;
    rutDeduction: boolean;
    salaryFreelancer: any | null;
    showDates: boolean;
    showHours: boolean;
    socialFeePer: number;
    socialFeePercentage: number;
    tax: number;
    taxReductionFortnoxId: number | null;
    taxfreeArticle: any | null;
    toPayAmont: number;
    totalAllowanceAbroadTaxFree: number | null;
    totalAllowanceAbroadTaxFreeNotShown: number | null;
    totalAllowanceAbroadTaxable: number | null;
    totalAllowanceAbroadTaxableNotShown: number | null;
    totalCurrencyMargin: number | null;
    totalDomesticAllowanceFullDayTaxFree: number | null;
    totalDomesticAllowanceFullDayTaxFreeNotShown: number | null;
    totalDomesticAllowanceFullDayTaxable: number | null;
    totalDomesticAllowanceFullDayTaxableNotShown: number | null;
    totalDomesticAllowanceHalfDayTaxFree: number | null;
    totalDomesticAllowanceHalfDayTaxFreeNotShown: number | null;
    totalDomesticAllowanceHalfDayTaxable: number | null;
    totalDomesticAllowanceHalfDayTaxableNotShown: number | null;
    totalExpenditureForMaterialsAndToolsAccordingToAttachedPdfTaxFreeNotShown: number | null;
    totalExpenditureForMaterialsAndToolsAccordingToAttachedPdfTaxable: number | null;
    totalExpenditureForMaterialsAndToolsAccordingToAttachedPdfTaxableNotShown: number | null;
    totalExpenditureForMaterialsAndToolsTaxable: number | null;
    totalGrossAmount: number | null;
    totalHourlyWagesHours: number | null;
    totalMileageTaxFree: number | null;
    totalMileageTaxFreeNotShown: number | null;
    totalMileageTaxable: number | null;
    totalMileageTaxableNotShown: number | null;
    totalPensionContribution: number | null;
    totalPostFeeAmount: number;
    totalRealPensionAmount: number | null;
    totalSocialFee: number | null;
    totalTravelAllowance: number | null;
    totalTravelCostsAccordingToAttachedPdfTaxFree: number | null;
    totalTravelCostsAccordingToAttachedPdfTaxFreeNotShown: number | null;
    userName: string;
    userSSN_DOB: string | null;
    vat: number;
    vatAmount: number | null;
    workingHours: WorkingHour[];
}

export interface DeductionParams {
    PageNumber: number;
    PageSize: number;
    tab?: number;
    year?: string | null;
    month?: string | null;
    searchQuery?: string | null;
    userId?: string | null;
}

export interface TimesheetDeductionParams {
    fromDate?: string;
    toDate?: string;
    customerId?: string | number;
    pageNumber: number;
    tab: number;
    searchQuery?: string;
    year?: string | null;
    month?: string | null;
}

export interface TimesheetDeductionItem {
    id: number;
    workingDescription: string;
    customerName: string;
    workingDate: string;
    amountPerUnit: number;
    unit: string;
    articleNumber?: string;
    [key: string]: any;
}

export interface TimesheetDeductionResponse {
    statusCode: number;
    message: string;
    response: TimesheetDeductionItem[];
    numberOfPages?: number;
    totalCount?: number;
}

/**
 * Fetches timesheet deductions for the Not Invoiced tab.
 * Corresponds to: GET /deductionsv2/get-timesheet-deductions
 */
export const getTimesheetDeductionsApi = async (
    params: TimesheetDeductionParams
): Promise<TimesheetDeductionResponse> => {
    try {
        const queryParams: any = {
            pageNumber: params.pageNumber,
            tab: params.tab,
        };
        if (params.fromDate !== undefined) queryParams.fromDate = params.fromDate;
        if (params.toDate !== undefined) queryParams.toDate = params.toDate;
        if (params.customerId !== undefined) queryParams.customerId = params.customerId;
        if (params.searchQuery !== undefined) queryParams.searchQuery = params.searchQuery;
        if (params.year !== undefined && params.year !== null) queryParams.year = params.year;
        if (params.month !== undefined && params.month !== null) queryParams.month = params.month;

        const response = await get('/deductionsv2/get-timesheet-deductions', queryParams);
        return response;
    } catch (error) {
        console.error('Error fetching timesheet deductions:', error);
        throw error;
    }
};

export interface DeductionResponse {
    statusCode: number;
    message: string;
    response: DeductionRecord[];
    totalCount?: number;
    numberOfPages?: number;
}

/**
 * Fetches all salary deductions with pagination and filtering.
 * Corresponds to: GET /api/Salary/deduction
 * @param params - The request parameters containing PageNumber, PageSize, fromDate, toDate, and searchQuery.
 * @returns The API response with deduction data.
 */
export interface DeductionReportParams {
    tab: number;
    pageNumber?: number;
    pageSize?: number;
    fromDate?: string;
    toDate?: string;
    searchQuery?: string;
}

/**
 * Fetches deduction report data.
 * Corresponds to: GET /deductionsv2/get-report
 */
export const fetchDeductionReport = async (
    params: DeductionReportParams
): Promise<DeductionResponse> => {
    try {
        const queryParams: any = { tab: params.tab };
        if (params.pageNumber !== undefined) queryParams.pageNumber = params.pageNumber;
        if (params.pageSize !== undefined) queryParams.pageSize = params.pageSize;
        if (params.fromDate !== undefined) queryParams.fromDate = params.fromDate;
        if (params.toDate !== undefined) queryParams.toDate = params.toDate;
        if (params.searchQuery !== undefined) queryParams.searchQuery = params.searchQuery;

        const response = await get('/deductionsv2/get-report', queryParams);
        return response;
    } catch (error) {
        console.error('Error fetching deduction report:', error);
        throw error;
    }
};

export const fetchSalaryDeductions = async (
    params: DeductionParams
): Promise<DeductionResponse> => {
    try {
        const queryParams: any = {
            PageNumber: params.PageNumber,
            PageSize: params.PageSize,
        };

        if (params.tab !== undefined) {
            queryParams.tab = params.tab;
        }

        if (params.year !== undefined && params.year !== null) {
            queryParams.year = params.year;
        }

        if (params.month !== undefined && params.month !== null) {
            queryParams.month = params.month;
        }

        if (params.searchQuery !== undefined && params.searchQuery !== null && params.searchQuery !== '') {
            queryParams.searchQuery = params.searchQuery;
        }

        if (params.userId !== undefined && params.userId !== null && params.userId !== '') {
            queryParams.customerId = params.userId;
        }

        const response = await get('/salarynoticev2/deduction', queryParams);
        return response;
    } catch (error) {
        console.error('Error fetching salary deductions:', error);
        throw error;
    }
};